import type { Tour } from '#domain/Tour.ts';

import { TourStatusData } from './TourStatusData.ts';

const TourProgressBar = ({ tour }: { tour: Tour }) => {
    const { color, icon, status } = TourStatusData[tour.status];

    const showProgress = status !== 'planned';

    const progressPercent =
        tour.progress.totalStopAmount > 0
            ? (tour.progress.finishedStopAmount / tour.progress.totalStopAmount) * 100
            : 0;

    return (
        <div className='display-flex gap-10 align-items-center padding-right-25 padding-top-5 padding-bottom-5'>
            <div
                className='position-relative flex-1-1-0'
                style={{ '--left': `${showProgress ? progressPercent : 0}%` } as React.CSSProperties}
            >
                <div className='progress'>
                    <div
                        className={`progress-bar ${status !== 'finished' ? 'progress-bar-striped progress-bar-animated' : ''} progress-bar-${color}`}
                        style={{ width: 'var(--left)' }}
                    />
                </div>

                {showProgress ? (
                    <span
                        style={{ left: 'var(--left)' }}
                        className={`badge badge-${color} shadow-accent position-absolute top-50pct translate${progressPercent === 0 ? '' : '-x-50pct'}-y-50pct display-grid place-items-center text-size-12 white-space-nowrap`}
                    >
                        {tour.progress?.finishedStopAmount} / {tour.progress?.totalStopAmount}
                    </span>
                ) : (
                    <span
                        className={`badge badge-${color} shadow-accent position-absolute top-50pct translate-y-50pct display-grid place-items-center white-space-nowrap`}
                    >
                        <span className={`rioglyph rioglyph-${icon} text-size-14`} />
                    </span>
                )}
            </div>
        </div>
    );
};

export default TourProgressBar;
